"use client";

import { ChakraProvider, defaultSystem } from "@chakra-ui/react";
import { ColorModeProvider, type ColorModeProviderProps } from "./color-mode";
import type { ReactNode } from "react";

type ProviderProps = ColorModeProviderProps & { children?: ReactNode };

export function Provider({ children, ...rest }: ProviderProps) {
  return (
    <ChakraProvider value={defaultSystem}>
      <ColorModeProvider {...(rest as ColorModeProviderProps)}>
        {children}
      </ColorModeProvider>
    </ChakraProvider>
  );
}
